import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

import premiumCreatorsIcon from "../../components/Main/Landing/images/premium-creators.png";
import exclusiveLifestyleIcon from "../../components/Main/Landing/images/exclusive-lifestyle.png";
import curatedExperienceIcon from "../../components/Main/Landing/images/curated-experience.png";
import privateCommunityIcon from "../../components/Main/Landing/images/private-community.png";
import verifiedPlatformIcon from "../../components/Main/Landing/images/verified-platform.png";

const useStyles = makeStyles((theme) => ({
  sectionOuter: {
    background: "#0d0d0d",
  },
  section: {
    maxWidth: '1314px',
    margin: '0 auto',
    padding: '45px 30px',
    textAlign: 'center',
    marginBottom: '60px',
    background: "#0d0d0d",
    [theme.breakpoints.down('sm')]: {
      padding: '40px 30px 48px 30px',
      marginBottom: '15px',
    }
  },
  sectionTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    lineHeight: '100%',
    marginBottom: '15px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
    }
  },
  sectionSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    color: '#FFFFFF',
    lineHeight: '27px',
    fontWeight: 200,
    marginBottom: '40px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
      marginBottom: '32px',
    }
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '32px 20px',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: '32px',
    }
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '0 20px',
    '&:not(:last-child)': {
      [theme.breakpoints.up('lg')]: {
        borderRight: '1px solid rgba(255, 255, 255, 0.1)',
      },
      [theme.breakpoints.down('xs')]: {
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        paddingBottom: '24px',
      }
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      textAlign: 'left',
      padding: '0',
    }
  },
  iconImg: {
    width: '48px',
    height: '48px',
    marginBottom: '20px',
    objectFit: 'contain',
    display: 'block',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '16px',
    }
  },
  colTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '24px',
    fontWeight: 500,
    color: '#ffffff',
    marginBottom: '8px',
    lineHeight: '100%',
    minHeight: '52px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '& br': {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      }
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: 'auto',
      display: 'block',
      textAlign: 'left',
      marginBottom: '6px',
      fontSize: '20px',
    }
  },
  colDesc: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    fontWeight: 200,
    color: '#FFFFFF',
    lineHeight: '27px',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left',
      fontSize: '16px',
      lineHeight: '24px',
    }
  }
}));

interface MemberFeatureItem {
  title: React.ReactNode;
  desc: string;
  icon: string;
}

const WHY_MEMBERS_DATA: MemberFeatureItem[] = [
  {
    title: <>Premium <br />Creators</>,
    desc: "Hand-selected for taste, consistency, and craft.",
    icon: premiumCreatorsIcon
  },
  {
    title: <>Exclusive lifestyle <br />content</>,
    desc: "Lifestyle stories found nowhere else online.",
    icon: exclusiveLifestyleIcon
  },
  {
    title: <>Curated <br />experiences</>,
    desc: "Every drop selected, never algorithm-fed.",
    icon: curatedExperienceIcon
  },
  {
    title: <>Private <br />community</>,
    desc: "A quieter corner of the platform, members only.",
    icon: privateCommunityIcon
  },
  {
    title: <>Verified <br />platform</>,
    desc: "Every creator and member checked before joining.",
    icon: verifiedPlatformIcon
  }
];

export const LifestyleWhyMembersSection = () => {
  const classes = useStyles();

  return (
    <Box className={classes.sectionOuter}>
      <Box className={classes.section}>
        <Typography className={classes.sectionTitle}>
          Why Members Love It
        </Typography>
        <Typography className={classes.sectionSubtitle}>
          The reasons this collection keeps members coming back.
        </Typography>

        <Box className={classes.grid}>
          {WHY_MEMBERS_DATA.map((item, index) => (
            <Box key={index} className={classes.column}>
              <img src={item.icon} alt="feature icon" className={classes.iconImg} />
              <Typography className={classes.colTitle}>
                {item.title}
              </Typography>
              <Typography className={classes.colDesc}>
                {item.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
